// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { RecipientType } from "../../data/messaging/recipient-type";
import { EmailMessageDocument } from "./documents/email-message-document";
import { ItemEnvelope } from "./base/item-envelope";

export class EmailMessageEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "EmailMessage");
		if (jsonEnvelope) {
			this.RecipientTypesPool = jsonEnvelope.RecipientTypesPool;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public RecipientTypesPool: RecipientType[] = [];
	public override Document: EmailMessageDocument = new EmailMessageDocument();
	public override get ItemId(): number { return this.Document.Item.EmailMessageId; }
	public override get ItemName(): string { return this.Document.Item.Subject; }
}